import ExcelJS from "exceljs";
import { courierCodeMap } from "./courierUtils";

export async function parseExcelToJson(file) {
  const workbook = new ExcelJS.Workbook();
  const buffer = await file.arrayBuffer();
  await workbook.xlsx.load(buffer);

  const worksheet = workbook.getWorksheet(1);
  const data = [];

  const headers = [];
  worksheet.getRow(1).eachCell((cell, colNumber) => {
    headers[colNumber] = cell.value;
  });

  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 1) {
      const rowData = {};
      row.eachCell((cell, colNumber) => {
        rowData[headers[colNumber]] = cell.value;
      });
      data.push(rowData);
    }
  });

  const groupedData = {};

  data.forEach((row) => {
    const id = row["고유식별번호"];

    if (!groupedData[id]) {
      groupedData[id] = {
        id: id,
        courier_company: row["택배사"] || "",
        courier_code: courierCodeMap[row["택배사"]] || "",
        tracking_number: row["운송장번호"] || "",
        products: [],
        sender_name: row["보내는사람이름"] || "",
        sender_phone: row["보내는사람연락처"] || "",
      };
    }

    if (row["상품명"] && row["상품코드"]) {
      groupedData[id].products.push({
        product_code: row["상품코드"] || "",
        product_name: row["상품명"] || "",
        product_option: row["상품옵션"] || "",
        quantity: parseInt(row["수량"]) || 1,
      });
    }
  });

  const result = Object.values(groupedData);

  return result;
}
